const modal = () => {
    const btnModals = document.querySelectorAll('.btnModal');
    const closeModals = document.querySelectorAll('.closeModal');
    const modalWindows = document.querySelectorAll('.modalWindow');
    const modalFeedback = document.querySelector('#modal-feedback');
    
    btnModals.forEach(btnModal => {
        btnModal.addEventListener('click', () => {
            modalFeedback.showModal();
        })
    });
  
    closeModals.forEach(closeModal => {
        closeModal.addEventListener('click', () => {
            modalWindows.forEach(modalWindow => {
                modalWindow.close();
            });   
        })
    })

    modalWindows.forEach(modalWindow => {
        modalWindow.addEventListener('click', (e) => {
            if(e.target === modalWindow ) modalWindow.close();
        });  
    })
  }
export default modal;